import { Capacitor } from '@capacitor/core';

/** Returns true when running inside a native iOS or Android shell */
export const isNative = (): boolean => Capacitor.isNativePlatform();

/** Returns true only on native iOS */
export const isIOS = (): boolean => Capacitor.getPlatform() === 'ios';

/** Returns true only on native Android */
export const isAndroid = (): boolean => Capacitor.getPlatform() === 'android';

/** Returns true when running in web browser (not Capacitor) */
export const isWeb = (): boolean => Capacitor.getPlatform() === 'web';
